<div class="admin-widget">
  <section class="admin-widget-content">
    <h5 class="admin-widget-content-subtitle">
      {{ 'platformWidget.admin.subtitle' | transloco }}
    </h5>
    <span
      slot="admin-widget-content-list"
      [innerHTML]="'platformWidget.admin.list' | transloco"
    ></span>
  </section>
  <markant-button
    class="flex-row-end"
    colorScheme="primary"
    variant="clear"
    data-cy="navigate-to-admin-area-from-widget-btn"
    [routerLink]="link"
  >
    <span>{{ 'platformWidget.admin.link' | transloco }}</span>
    <markant-icon icon="m_arrow-right" slot="icon-trailing"></markant-icon>
  </markant-button>
</div>
